module.exports = "https://assets.pclncdn.com/web/next-landing/03c4f86f87/_next/static/images/card-46f5bcb5ad798f1803a957189347cd33.jpg";